import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { buildAppInsightsConfig } from "@/config/appInsightsConfig";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: buildAppInsightsConfig(
        import.meta.env.VITE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
        [reactPlugin],
    ),
});

appInsights.loadAppInsights();
export { appInsights, reactPlugin };
